import { chains, } from "@bracket/chainography";
import type { ValidChainId, } from "./ValidChainId";

/** a valid and supported token symbol for a specific chain */
export declare type TokenSymbol<C extends ValidChainId = 1> = Uppercase<string & keyof typeof import("@bracket/chainography").chains[C]["tokens"]>;


/**
 * Checks if a value is a valid token symbol for a specific chain
 * @param {unknown} value - The value to check
 * @param {C} chainId - The chain ID to check against
 * @returns {boolean} True if the value is a valid token symbol for the specified chain
 * @template C - The chain ID type, defaults to 1
 */
export const isTokenSymbol = <C extends ValidChainId = 1>( value: unknown, chainId: C, ): value is TokenSymbol<C> => {
  if(typeof value === "string") {
    return value in chains[chainId].tokens;
  }
  return false;
}

